import React, { FC } from "react";
import injectSheet from "react-jss";

interface Props {
  classes: any;
  useFixedWidth?: boolean;
  style?: any;
}
import styleSheet from "./styles";

const Wrapper: FC<any> = ({
  classes,
  style,
  useFixedWidth = true,
  children
}) => (
  <div
    style={style}
    className={`${classes.wrapper} ${
      useFixedWidth ? classes.wrapperFixedWidth : ""
    }`}
  >
    {children}
  </div>
);
export default injectSheet(styleSheet)(Wrapper);
